import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de alertas — lista pública, sem guard: alerta de emergência é
 * exatamente o conteúdo que um convidado precisa ver sem barreira (P2).
 */

const AlertsPage = lazy(() => import('./routes/Alerts.page'));

export const alertsRoutes: RouteObject[] = [{ path: 'alerts', element: <AlertsPage /> }];
